import { Breadcrumb, Button, Card, Empty, Modal, Tabs } from "antd";
import { useNavigate } from "react-router";
import { ReactComponent as TitleIcon } from "../../assests/images/transbreadhistory.svg";
import { useTranslation } from "react-i18next";
import { useCallback, useEffect, useState } from "react";
import SendMoneyService from "../../services/send-money.service";
import moment from "moment";
import PaymentService from "../../services/payments.service";
import TransferService from "../../services/transfer.service";
import UploadHistory from "../../components/upload-history";
import { amountFormat } from "../../services/common.service";
import { ReactComponent as DownloadIcon } from "../../assests/icons/download.svg";
import PendingAuthService from "../../services/approvals.service";
import FEATURE_CONFIG from "client/feature.config.json";
import { ReactComponent as HomeIcon } from "../../assests/images/home-line.svg";
import PaginationComponent from "../../components/paginationComponet";

export default function AllTransactionHistory() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("FUNDTRANSFER");
  const [size, setSize] = useState(20);
  const [hasMoreRecords, setHasMoreRecords] = useState(false);
  const [dataSource, setDataSource] = useState([]);
  const [visible, setVisible] = useState(false);
  const [visiblePayment, setVisiblePayment] = useState(false);
  const [details, setDetails] = useState({});
  const paymentTypes = {
    ONCE: "One Time",
    RECURRING: "Recurring SI",
    SCHEDULED: "One Time - Scheduled",
  };
  const transferTypes = {
    // TISS: t("pages.sendMoney.common_sendMoney.tiss", {
    //   defaultValue: "TISS",
    // }),
    // EFT: t("pages.sendMoney.common_sendMoney.eft", {
    //   defaultValue: "EFT",
    // }),
    // TIPS: "TIPS",
    IAT: t("pages.sendMoney.common_sendMoney.within_bank", {
      defaultValue: "Within Bank",
    }),
    OAT: t("common.own_account", { defaultValue: "Own Account" }),
    // SWIFT: t("pages.Add_Bene.international", {
    //   defaultValue: "International",
    // }),
    ...(FEATURE_CONFIG.ADD.DOMESTIC_BENE && { ABC: "ABC" }),
  };
  useEffect(() => {
    transactionHistory(0, 1000, "");
  }, []);

  const [data, setData] = useState([]);
  useEffect(() => {
    setData(dataSource.slice(0, 10));
  }, [dataSource]);

  const handlePageChange = (currentPage, slicedData) => {
    setData(slicedData);
  };
  const transactionHistory = useCallback(async (page, size) => {
    try {
      const response = await SendMoneyService.transactionHistory({
        page: page,
        size: size,
        transferType: "",
        status: " ",
      });
      if (response.status === 200) {
        setDataSource(response.data["data"]);
        setHasMoreRecords(
          response.data["pagination"]["totalElements"] !==
            response.data["data"].length
        );
      }
    } catch (error) {}
  }, []);

  const paymentHistory = useCallback(async (page, size, transferType) => {
    try {
      const response = await PaymentService.paymentHistory({
        page: page,
        size: size,
        transferType: transferType,
      });
      if (response.status === 200) {
        setDataSource(response.data["data"]);
        setHasMoreRecords(
          response.data["pagination"]["totalElements"] !==
            response.data["data"].length
        );
      }
    } catch (error) {}
  }, []);

  const getUploadHistory = useCallback(async () => {
    try {
      const response = await TransferService.getUploadHistory({
        module: "FILEUPLOAD",
      });
      if (response.status === 200) {
        setDataSource(response.data);
      }
    } catch (err) {}
  }, []);

  const getBulkUploadHistory = useCallback(async () => {
    try {
      const response = await TransferService.getUploadHistory({
        module: "BULKUPLOAD",
      });
      if (response.status === 200) {
        setDataSource(response.data);
      }
    } catch (err) {}
  }, []);

  const governmentPaymentHistory = useCallback(async (page, size) => {
    try {
      const response = await PaymentService.gepg_History({
        page: page,
        size: size,
      });
      if (response.status === 200) {
        setDataSource(response.data["data"]);
        setHasMoreRecords(
          response.data["pagination"]["totalElements"] !==
            response.data["data"]?.length
        );
      }
    } catch (error) {}
  }, []);

  const handleTabChange = (key) => {
    setActiveTab(key);
    setHasMoreRecords(false);
    setSize(20);
    setDataSource([]);
    setData([]);
    if (key === "FUNDTRANSFER") {
      transactionHistory(0, 1000, "");
    } else if (key === "BILLPAYMENT") {
      paymentHistory(0, 1000, "");
    } else if (key === "SALARYUPLOAD") {
      getUploadHistory();
    } else if (key === "BULKUPLOAD") {
      getBulkUploadHistory();
    } else if (key === "GEPG") {
      governmentPaymentHistory(0, 1000, "");
    }
  };

  const loadMoreData = useCallback(() => {
    setSize(size + 20);
    if (activeTab === "FUNDTRANSFER") {
      transactionHistory(0, size + 20, "");
    } else if (activeTab === "BILLPAYMENT") {
      paymentHistory(0, size + 20, "");
    } else if (activeTab === "GEPG") {
      governmentPaymentHistory(0, size + 20, "");
    }
  }, [
    activeTab,
    size,
    transactionHistory,
    paymentHistory,
    governmentPaymentHistory,
  ]);

  const handleDownload = useCallback(async (selected) => {
    try {
      const reqParams = {
        txnId: selected?.txnId,
      };
      setVisible(false);
      setVisiblePayment(false);
      await PendingAuthService.downloadReceipts(reqParams);
    } catch (err) {}
  }, []);

  const handlebillerDownload = useCallback(async (selected) => {
    try {
      const reqParams = {
        txnId: selected?.billTxnId,
        status: selected?.billPaymentStatus,
      };
      setVisible(false);
      await PendingAuthService.downloadPaymentReceipts(reqParams);
    } catch (err) {}
  }, []);

  return (
    <>
        {/* <Breadcrumb separator=">">
          <Breadcrumb.Item>
            <span onClick={() => navigate("/dashboard")}>
              <HomeIcon height={14}/>
            </span>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <span>
              {t("navigation.trans_history", {
                defaultValue: "Transaction History",
              })}
            </span>
          </Breadcrumb.Item>
        </Breadcrumb> */}
      <Card size="small" className="mb-1 text-center breadcrumb-title-card">
        <div className="row">
          <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 d-flex justify-content-left align-items-center heading mx-0">
            {/* <TitleIcon height={30} style={{ marginLeft: "-20px" }} /> */}
            <h3 className="title mb-0">
              {t("navigation.trans_history", {
                defaultValue: "Transaction History",
              })}
            </h3>
          </div>
        </div>
      </Card>
      <Card className="application-card">
        <Tabs
          defaultActiveKey="FUNDTRANSFER"
          type="line"
          onChange={handleTabChange}
          activeKey={activeTab}
        >
          {FEATURE_CONFIG.TRANSACTION_HISTORY.FUND_TRANSFER && (
            <Tabs.TabPane
              tab={t("pages.fundtransfer.fund_transfer", {
                defaultValue: "Fund Transfer",
              })}
              key="FUNDTRANSFER"
            />
          )}
          {FEATURE_CONFIG.TRANSACTION_HISTORY.BILL_PAYMENT && (
            <Tabs.TabPane
              tab={t("navigation.payments", {
                defaultValue: "Payments",
              })}
              key="BILLPAYMENT"
            />
          )}
          {FEATURE_CONFIG.TRANSACTION_HISTORY.SALARY_UPLOAD && (
            <Tabs.TabPane
              tab={t("navigation.salary_upload", {
                defaultValue: "Salary Upload",
              })}
              key="SALARYUPLOAD"
            />
          )}
          {FEATURE_CONFIG.TRANSACTION_HISTORY.BULK_UPLOAD && (
            <Tabs.TabPane
              tab={t("navigation.bulk_upload", {
                defaultValue: "Bulk Payment Upload",
              })}
              key="BULKUPLOAD"
            />
          )}
          {FEATURE_CONFIG.TRANSACTION_HISTORY.GEPG && (
            <Tabs.TabPane
              tab={t("navigation.gepg", {
                defaultValue: "GePG",
              })}
              key="GEPG"
            />
          )}
        </Tabs>
        {dataSource.length === 0 && (
          <Empty
            description={t("pages.transfer_limit.no_record_found", {
              defaultValue: "No Record found",
            })}
          />
        )}
        {dataSource.length > 0 && (
          <div>
            {activeTab === "SALARYUPLOAD" ? (
              <UploadHistory dataSource={dataSource} />
            ) : activeTab === "BULKUPLOAD" ? (
              <UploadHistory dataSource={dataSource} />
            ) : activeTab === "BILLPAYMENT" ? (
              <div className="ft-table">
                <table className="table">
                  <thead style={{ backgroundColor: "#F1F1F1" }}>
                    <tr>
                      <th>
                        {" "}
                        {t("pages.gepeg.ref_no", {
                          defaultValue: "Reference Number",
                        })}
                      </th>
                      <th>
                        {" "}
                        {t("pages.pay_bills.biller_name", {
                          defaultValue: "Biller Name",
                        })}
                      </th>
                      <th>
                        {" "}
                        {t("pages.pay_bills.consumer_id", {
                          defaultValue: "Consumer ID",
                        })}
                      </th>
                      <th>
                        {t("pages.pending_approval.token", {
                          defaultValue: "Token",
                        })}
                      </th>
                      <th>
                        {t("pages.dashboard.transaction_date", {
                          defaultValue: "Transaction Date",
                        })}
                      </th>
                      <th>{t("common.amount", { defaultValue: "Amount" })}</th>
                      <th>{t("common.status", { defaultValue: "Status" })}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data.map((option, idx) => (
                      <tr
                        key={idx}
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          setDetails(option);
                          setVisiblePayment(true);
                        }}
                      >
                        <td>
                          <span
                            // className="pay-now-text"
                            // style={{ textDecoration: "underline" }}
                            onClick={(e) => {
                              e.stopPropagation();
                              e.preventDefault();
                              handlebillerDownload(option);
                            }}
                          >
                            {option.transferRefNo || "-"}
                            {/* <img
                              alt="download"
                              src={download}
                              height={18}
                              style={{ marginLeft: "10px" }}
                            /> */}
                            <DownloadIcon
                              height={18}
                              style={{ marginLeft: "10px" }}
                            />
                          </span>
                        </td>{" "}
                        <td
                          style={{
                            whiteSpace: "break-spaces",
                            wordBreak: "break-all",
                          }}
                        >
                          {option.billerName || "-"}
                        </td>
                        <td>{option.consumerId}</td>
                        <td
                          style={{
                            whiteSpace: "break-spaces",
                            wordBreak: "break-all",
                          }}
                        >
                          {option.billRefNo || "-"}
                        </td>
                        <td>
                          {option?.initDate &&
                            (moment(option?.initDate).format("DD-MM-YYYY") ||
                              "-")}
                        </td>
                        <td>
                          <td className="d-flex justify-content-between">
                            <span>
                              {amountFormat(option.amount, option?.txnCcy)}
                            </span>
                          </td>
                        </td>
                        <td>
                          {option.billPaymentStatus !== "SUCCESS" &&
                          option.billPaymentStatus !== null ? (
                            <span className="fail-error px-2 py-1">
                              {option.billPaymentStatus}
                            </span>
                          ) : option.billPaymentStatus === "SUCCESS" ? (
                            <span className="success-text px-2 py-1">
                              {option.billPaymentStatus}
                            </span>
                          ) : option.billPaymentStatus === null ? (
                            "-"
                          ) : null}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                  <tfoot>
                  <tr>
                  <td colSpan="8"> 
                  {dataSource.length > 10 && (
                    <PaginationComponent
                      dataSource={dataSource}
                      pageSize={10}
                      onPageChange={handlePageChange}
                    />
                    )}
                    </td>
                    </tr>
                  </tfoot>
                </table>
              </div>
            ) : activeTab === "GEPG" ? (
              <div className="ft-table">
                <table className="table">
                  <thead style={{ backgroundColor: "#F1F1F1" }}>
                    <tr>
                      <th>
                        {t("pages.gepeg.source_account", {
                          defaultValue: "Source Account",
                        })}
                      </th>
                      <th>
                        {t("pages.gepeg.bill_control_no", {
                          defaultValue: "Bill Control No",
                        })}
                      </th>
                      <th>
                        {t("pages.gepeg.bill_currency", {
                          defaultValue: "Bill Currency",
                        })}
                      </th>
                      <th>
                        {t("common.transaction_date", {
                          defaultValue: "Transaction Date",
                        })}
                      </th>
                      <th>
                        {t("pages.gepeg.paid_amount", {
                          defaultValue: "Paid Amount",
                        })}
                      </th>
                      <th>{t("common.status", { defaultValue: "Status" })}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data.map((option, idx) => (
                      <tr
                        key={idx}
                        onClick={() => {
                          setDetails(option);
                          setVisible(true);
                        }}
                        style={{ cursor: "pointer" }}
                      >
                        <td>{option.debitAccount}</td>
                        <td>{option.controlNum || "-"}</td>
                        <td>{option.billCcy || "-"}</td>
                        <td>
                          {option?.initDate && (
                            <span>
                              {moment(option?.initDate).format("DD-MM-YYYY") ||
                                "-"}
                            </span>
                          )}
                        </td>
                        <td>
                          {amountFormat(option.paidAmount, option?.debitCcy)}
                        </td>
                        <td>
                          {option?.status === "SUCCESS" ? (
                            <span className="success-text px-2 py-1">
                              {t("common.success_cap", {
                                defaultValue: "SUCCESS",
                              })}
                            </span>
                          ) : option?.status == null ? (
                            <span className="px-2 py-1">-</span>
                          ) : (
                            <span className="fail-error px-2 py-1">
                              {option?.status || "-"}
                            </span>
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                  <tfoot>
                  <tr>
                  <td colSpan="8"> 
                  {dataSource.length > 10 && (
                    <PaginationComponent
                      dataSource={dataSource}
                      pageSize={10}
                      onPageChange={handlePageChange}
                    />
                    )}
                    </td>
                    </tr>
                  </tfoot>
                </table>
              </div>
            ) : (
              <div className="ft-table">
                <table className="table">
                  <thead style={{ backgroundColor: "#F1F1F1" }}>
                    <tr>
                      <th
                        title={t("pages.gepeg.ref_no", {
                          defaultValue: "Reference Number",
                        })}
                      >
                        {" "}
                        {t("pages.gepeg.ref_no", {
                          defaultValue: "Reference Number",
                        })}
                      </th>
                      <th
                        title={t("pages.gepeg.source_account", {
                          defaultValue: "Source Account",
                        })}
                      >
                        {t("pages.gepeg.source_account", {
                          defaultValue: "Source Account",
                        })}
                      </th>
                      <th
                        title={t("pages.Add_Bene.bane_name", {
                          defaultValue: "Beneficiary Name",
                        })}
                      >
                        {t("pages.Add_Bene.bane_name", {
                          defaultValue: "Beneficiary Name",
                        })}
                      </th>
                      <th
                        title={t("pages.standing_instruction.bene_acc_no", {
                          defaultValue: "Beneficiary Account Number",
                        })}
                      >
                        {t("pages.standing_instruction.bene_acc_no", {
                          defaultValue: "Beneficiary Account Number",
                        })}
                      </th>
                      <th>
                        {t("pages.payment_history.transfer_type", {
                          defaultValue: "Transfer Type",
                        })}
                      </th>
                      <th>
                        {t("pages.view_scheduled_transfer.payment_type", {
                          defaultValue: "Payment Type",
                        })}
                      </th>

                      <th>{t("common.amount", { defaultValue: "Amount" })}</th>
                      <th
                        title={t("pages.dashboard.transaction_date", {
                          defaultValue: "Transaction Date",
                        })}
                      >
                        {t("pages.dashboard.transaction_date", {
                          defaultValue: "Transaction Date",
                        })}
                      </th>
                      <th
                        title={t("pages.pending_approval.transaction_status", {
                          defaultValue: "Transaction status",
                        })}
                      >
                        {t("pages.pending_approval.transaction_status", {
                          defaultValue: "Transaction status",
                        })}
                      </th>
                      <th>{t("common.status", { defaultValue: "Status" })}</th>
                    </tr>
                  </thead>

                  <tbody style={{ cursor: "pointer" }}>
                    {data.map((option, idx) => (
                      <tr
                        key={idx}
                        onClick={() => {
                          setDetails(option);
                          setVisible(true);
                        }}
                      >
                        <td>
                          <span
                            // className="pay-now-text"
                            // style={{ textDecoration: "underline" }}
                            onClick={(e) => {
                              e.stopPropagation();
                              e.preventDefault();
                              handleDownload(option);
                            }}
                          >
                            {option.refNo || "-"}
                            {/* <img
                              alt="download"
                              src={download}
                              height={18}
                              style={{ marginLeft: "10px" }}
                            /> */}
                            <DownloadIcon
                              height={18}
                              style={{ marginLeft: "10px" }}
                            />
                          </span>
                        </td>{" "}
                        <td>{option.srcAccount || "-"}</td>
                        <td title={option?.destAccName}>
                          {option.destAccName}
                        </td>
                        <td>{option.destAccount || "-"}</td>
                        <td
                          title={
                            option.transferType === "IAT"
                              ? t("pages.fundtransfer.internal_account_transfer", {
                                  defaultValue: "Internal Account Transfer",
                                })
                              : option?.transferType === "OAT"
                              ? t("navigation.own_transfer", {
                                  defaultValue: "Own Account Transfer",
                                })
                              : option?.transferType
                          }
                        >
                          {option.transferType === "IAT"
                            ? t("pages.fundtransfer.internal_account_transfer", {
                                defaultValue: "Internal Account Transfer",
                              })
                            : option?.transferType === "OAT"
                            ? t("navigation.own_transfer", {
                                defaultValue: "Own Account Transfer",
                              })
                            : option?.transferType}
                        </td>
                        <td title={paymentTypes[option?.paymentType]}>
                          {paymentTypes[option?.paymentType]}
                        </td>
                        <td>{amountFormat(option.amount, option?.txnCcy)}</td>
                        <td>
                          {(option?.txnDate &&
                            moment(option?.txnDate).format("DD-MM-YYYY")) ||
                            "-"}
                        </td>
                        <td>
                          {option?.txnStatus ===
                            "FXDEAL_BANKADMIN_APPROVAL_PENDING" ||
                          option?.txnStatus === "PENDING" ||
                          option?.txnStatus === "P" ? (
                            <span className="fail-error px-2 py-1">
                              {t("pages.pending_approval.pending", {
                                defaultValue: "PENDING",
                              })}
                            </span>
                          ) : option?.txnStatus === "FAIL" ? (
                            <span className="fail-error px-2 py-1">
                              {" "}
                              {t("pages.pending_approval.fail", {
                                defaultValue: "FAIL",
                              })}
                            </span>
                          ) : option?.txnStatus === "REJECTED" ? (
                            <span className="fail-error px-2 py-1">
                              {t("pages.pending_approval.rejected", {
                                defaultValue: "REJECTED",
                              })}
                            </span>
                          ) : (
                            <span className="success-text px-2 py-1">
                              {option?.txnStatus}
                            </span>
                          )}
                        </td>
                        <td>
                          {option.authStatus === "A" ? (
                            <span className="success-text px-2 py-1">
                              {t("pages.pending_approval.authorised", {
                                defaultValue: "AUTHORISED",
                              })}
                            </span>
                          ) : option.authStatus === "RN" ? (
                            <span className="fail-error px-2 py-1">
                              {t("pages.pending_approval.returned", {
                                defaultValue: "RETURNED",
                              })}
                            </span>
                          ) : option.authStatus === "R" ? (
                            <span className="fail-error px-2 py-1">
                              {t("pages.pending_approval.rejected", {
                                defaultValue: "REJECTED",
                              })}
                            </span>
                          ) : (
                            <span className="fail-error px-2 py-1">
                              {option.authStatus}
                            </span>
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                  <tfoot>
                  <tr>
                  <td colSpan="8"> 
                  {dataSource.length > 10 && (
                    <PaginationComponent
                      dataSource={dataSource}
                      pageSize={10}
                      onPageChange={handlePageChange}
                    />
                    )}
                    </td>
                    </tr>
                  </tfoot>
                </table>
              </div>
            )}
          </div>
        )}
        {hasMoreRecords && dataSource.length !== 0 && (
          <div align="center">
            <Button type="default" onClick={() => loadMoreData()}>
              {t("buttons.load_more_records_btn", {
                defaultValue: "Load More Records",
              })}
            </Button>
          </div>
        )}
      </Card>

      <Modal
        title={""}
        open={visible}
        footer={null}
        width={750}
        closable={false}
        maskClosable={false}
        mask={true}
        centered
      >
        <h3 className="primary-title">
          {t("common.transaction_details", {
            defaultValue: "Transaction Details",
          })}
        </h3>

        <div className="row">
          <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 confirm-details">
            <div className="row" style={{ padding: "0 30px" }}>
              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-4 col-xl-4 mb-3">
                <label>
                  {t("pages.gepeg.source_account", {
                    defaultValue: "Source Account",
                  })}
                </label>
                <span>{details?.srcAccount}</span>
              </div>
              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-4 col-xl-4 mb-3">
                <label>
                  {t("common.destination_account", {
                    defaultValue: "Destination Account",
                  })}
                </label>
                <span>{details?.destAccount}</span>
              </div>
              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-4 col-xl-4 mb-3">
                <label>
                  {" "}
                  {t("common.transferred_amount", {
                    defaultValue: "Transferred Amount",
                  })}
                </label>
                <span> {amountFormat(details?.amount, details?.txnCcy)}</span>
              </div>
              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-4 col-xl-4 mb-3">
                <label>
                  {t("pages.dashboard.transaction_date", {
                    defaultValue: "Transaction Date",
                  })}
                </label>
                <span>
                  {" "}
                  {(details?.txnDate &&
                    moment(details?.txnDate).format("DD-MM-YYYY")) ||
                    "-"}
                </span>
              </div>

              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-4 col-xl-4 mb-3">
                <label>
                  {t("pages.payment_history.transfer_type", {
                    defaultValue: "Transfer Type",
                  })}
                </label>
                <span> {transferTypes[details?.transferType]}</span>
              </div>
              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-4 col-xl-4 mb-3">
                <label>
                  {" "}
                  {t("pages.gepeg.ref_no", {
                    defaultValue: "Reference Number",
                  })}
                </label>
                <span>{details?.refNo || "-"}</span>
              </div>
              {details?.fxDealNo && (
                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-4 col-xl-4 mb-3">
                  <label>
                    {t("pages.fundtransfer.fxno", {
                      defaultValue: "Fx Ref Number",
                    })}
                  </label>
                  <span> {details.fxDealNo}</span>
                </div>
              )}

              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-4 col-xl-4 mb-3">
                <label>
                  {t("pages.view_scheduled_transfer.payment_type", {
                    defaultValue: "Payment Type",
                  })}
                </label>
                <span>{paymentTypes[details?.paymentType]}</span>
              </div>

              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-4 col-xl-4 mb-3">
                <label>{t("common.status", { defaultValue: "Status" })}</label>
                <span>{details?.txnStatus}</span>
              </div>
              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-4 col-xl-4 mb-3">
                <label>
                  {t("common.remarks", { defaultValue: "Reason" })}
                </label>
                <span>{details?.remarksTag || details?.remarks || "-"}</span>
              </div>
            </div>
          </div>
        </div>

        <div className="d-flex align-items-center justify-content-end mt-5">
          <Button
            onClick={() => setVisible(false)}
            className="secondary-btn"
            type="default"
            size="large"
          >
            {t("buttons.close_btn", { defaultValue: "Close" })}
          </Button>
          {/* <Button
            size="large"
            onClick={() => handleDownload(details)}
            type="primary"
            className="primary-btn mx-3"
          >
            {t("buttons.download_btn", { defaultValue: "Download" })}
          </Button> */}
        </div>
      </Modal>
      <Modal
        title={""}
        open={visiblePayment}
        footer={null}
        width={750}
        closable={false}
        maskClosable={false}
        mask={true}
        centered
      >
        <h3 className="primary-title">
          {t("common.transaction_details", {
            defaultValue: "Transaction Details",
          })}
        </h3>

        <div className="row">
          <div className="col-12">
            <div className="row">
              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
                <span className="lbl-receipt">
                  {t("pages.gepeg.source_account", {
                    defaultValue: "Source Account",
                  })}
                </span>
                <p className="value-receipt">{details?.srcAccount}</p>
              </div>

              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
                <span className="lbl-receipt">
                  {" "}
                  {t("pages.pay_bills.category_name", {
                    defaultValue: "Category Name",
                  })}{" "}
                </span>
                <p className="value-receipt">{details?.categoryName}</p>
              </div>

              {/* <div className="col-xs-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
                <span className="lbl-receipt">
                  {" "}
                  {t("pages.pay_bills.biller_id", {
                    defaultValue: "Biller ID",
                  })}{" "}
                </span>
                <p className="value-receipt">{details?.billerId}</p>
              </div> */}

              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
                <span className="lbl-receipt">
                  {" "}
                  {t("pages.pay_bills.consumer_id", {
                    defaultValue: "Consumer ID",
                  })}
                </span>
                <p className="value-receipt">{details?.consumerId}</p>
              </div>
              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
                <div className="lbl-receipt">
                  {t("pages.pending_approval.service_name", {
                    defaultValue: "Service Name",
                  })}
                </div>
                <p className="value-receipt">{details?.serviceName}</p>
              </div>
              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
                <span className="lbl-receipt">
                  {t("pages.pay_bills.biller_name", {
                    defaultValue: "Biller Name",
                  })}
                </span>
                <p className="value-receipt">{details?.billerName}</p>
              </div>

              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
                <span className="lbl-receipt">
                  {t("common.mobile_number", {
                    defaultValue: "Mobile Number",
                  })}
                </span>
                <p className="value-receipt">{details?.mobileNo}</p>
              </div>

              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
                <div className="lbl-receipt">
                  {t("common.amount", { defaultValue: "Amount" })}{" "}
                </div>
                <p className="value-receipt">
                  {amountFormat(details?.amount, details?.txnCcy)}
                </p>
              </div>
              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
                <div className="lbl-receipt">
                  {t("common.payment_date", { defaultValue: "Payment Date" })}{" "}
                </div>
                <p className="value-receipt">
                  {(details?.initDate &&
                    moment(details?.initDate).format("DD-MM-YYYY")) ||
                    "-"}
                </p>
              </div>
              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
                <div className="lbl-receipt">
                  {t("pages.pending_approval.token", {
                    defaultValue: "Token",
                  })}{" "}
                </div>
                <p className="value-receipt">{details?.billRefNo || "-"}</p>
              </div>
              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
                <div className="lbl-receipt">
                  {" "}
                  {t("pages.gepeg.ref_no", {
                    defaultValue: "Reference Number",
                  })}{" "}
                </div>
                <p className="value-receipt">{details?.transferRefNo || "-"}</p>
              </div>

              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
                <div className="lbl-receipt">
                  {t("common.payment_status", {
                    defaultValue: "Payment Status",
                  })}{" "}
                </div>
                <p className="value-receipt">
                  {details?.billPaymentStatus || "-"}
                </p>
              </div>
              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
                <div className="lbl-receipt">
                  {t("common.remarks", { defaultValue: "Reason" })}{" "}
                </div>
                <p className="value-receipt">
                  {details?.initiatorRemarks || "-"}
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="d-flex align-items-center justify-content-end mt-5">
          <Button
            onClick={() => setVisiblePayment(false)}
            className="secondary-btn"
            type="default"
            size="large"
          >
            {t("buttons.close_btn", { defaultValue: "Close" })}
          </Button>
          {/* <Button
            size="large"
            onClick={() => handleDownload(details)}
            type="primary"
            className="primary-btn mx-3"
          >
            {t("buttons.download_btn", { defaultValue: "Download" })}
          </Button> */}
        </div>
      </Modal>
    </>
  );
}
